import { panelLandingRoute } from "../../../Components/ModuleSelection/moduleAccess";
import {
  Layout,
  Col,
  Row,
  Input,
  Image,
  Avatar,
  Divider,
  Space,
  Typography,
  Dropdown,
  Menu,
  Grid,
  InputRef,
  Button,
  Modal,
  Result,
  message,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import logo from "@assets/SVG/logo.svg";
import { Icon } from "@iconify/react";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { useAuth } from "@hooks/useAuth";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Header.module.scss";
import { Roles } from "~/Utils/Roles";
import { get, put } from "@services/api.service";
import { useNotification } from "~/Hooks/useNotification";
import { imageKey, mediaHost } from "~/Utils";
import cs from "classnames";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import gpt from "~/Assets/SVG/gptSupport.svg";
import { useHasAccess } from "@hooks/useHasAccess";

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const Header = () => {
  const [searchText, setSearchText] = useState("");
  const { user, logout } = useAuth();
  const [profileDetails, setProfileDetails] = useState<any>({});
  const [nameLogo, setNameLogo] = useState<string>();
  const [allRoles, setAllRoles] = useState<any[]>();
  const [currentRole, setCurrentRole] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [, setUser] = useLocalStorage("user", {});
  const [storedPanelUser] = useLocalStorage("panelUser", {});
  const { lg, md, xs } = useBreakpoint();
  const { openToast } = useNotification();
  const navigate = useNavigate();
  const location = useLocation();
  const extras = useRef<HTMLDivElement>(null);
  const searchBar = useRef<InputRef>(null);
  const { hasRole } = useHasAccess();
  const [isMobile, setIsMobile] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const activeSpaUsers = localStorage.getItem("inactiveSpaUser");

      const handleSpaNavigation = () => {
      if (activeSpaUsers === "false") {
        message.error("De-activated User");
        return;
      }
  
      navigate("/dashboard");
    };

  if (!user && (!storedPanelUser || Object.keys(storedPanelUser).length === 0)) {
    navigate("/auth/login");
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const activeUser = useMemo(() => {
    const path = location?.pathname || "";
    const isPanelRoute = /workorder/.test(path.toLowerCase());
    return isPanelRoute ? (storedPanelUser && Object.keys(storedPanelUser).length ? storedPanelUser : user) : user;
  }, [location?.pathname, storedPanelUser, user]);

  useEffect(() => {
    const u = activeUser;
    if (!u) return;

    if ((u.email && !u.userName) || (u.role === "CLM_USER" && !u.userName)) {
      get(`v1/user/details/profile`)
        .then((res: any) => {
          if (res.response.data) {
            if (u === user) {
              setUser({
                ...u,
                userLogo: res.response.data.userLogo,
                userName: res.response.data.userName,
              });
            }
            setProfileDetails(res.response.data);
          }
        })
        .catch();
    } else {
      setProfileDetails({
        userLogo: u.userLogo,
        userName: u.userName,
      });
    }
  }, [activeUser]);

  useEffect(() => {}, []);

  const getRole = (role: string) => {
    if (!role) return "";
    switch (role) {
      case Roles.SPA_USER:
      case "SPA_USER":
        return "SPA User";
      case Roles.SPA_REVIEWER:
      case "SPA_REVIEWER":
        return "SPA Reviewer";
      case Roles.SPA_ADMIN:
      case "SPA_ADMIN":
        return "SPA Admin";
      case Roles.SPA_APPROVER:
      case "SPA_APPROVER":
        return "SPA Approver";

      case "PANEL_ADMIN":
        return "Work order Admin";
      case "PANEL_CREATOR":
        return "Work order Creator";
      case "PANEL_REVIEWER":
        return "Work order Approver";
      case "PANEL_MASTER_REVIEWER":
      case "PANEL_MASTER_ADMIN":
        return "Work order Master Admin";

      default:
        return "";
    }
  };

  useEffect(() => {
    if (profileDetails?.userName) {
      const nameArray = profileDetails.userName.split(" ");
      const firstName = nameArray[0]?.charAt(0) || "";
      const lastName = nameArray.length > 1 ? nameArray[nameArray.length - 1]?.charAt(0) : "";

      const displayText = `${firstName}${lastName}`.toUpperCase();
      setNameLogo(displayText);
    }
  }, [profileDetails]);

  const logoStyle = isMobile ? { width: 100, cursor: "pointer" } : { maxWidth: 120, cursor: "pointer" };

  return (
    <Layout.Header
      className={cs(styles.header, {
        [styles.SmallHeader]: xs,
      })}
    >
      <Row
        align="middle"
        gutter={[16, 16]}
        style={{ height: "100%" }}
      >
        <Col
          span={2}
          className={styles.logoStyle}
        >
          <Image
            src={`${mediaHost}/images/branding/logo.png${imageKey}`}
            preview={false}
            style={logoStyle}
            onClick={() => {
              window.location.assign(panelLandingRoute());
            }}
          />
        </Col>
        <Col span={3}></Col>
        <Col
          span={7}
          style={{ display: "flex" }}
        ></Col>
        <Col
          span={12}
          style={{ textAlign: "right", justifyContent: "space-between" }}
        >
          <div
            className={styles.NavExtras}
            ref={extras}
            style={{
              marginLeft: "auto",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              lineHeight: 1.2,
              gap: 16,
            }}
          >
            <Button
              type="primary"
              onClick={() => setOpenConfirmationModal(true)}
            >
              ePOD
            </Button>
            <Typography.Link>
              <Dropdown
                overlay={
                  <Menu>
                    {!lg && (
                      <Menu.Item
                        key="profile"
                        disabled
                      >
                        <Space
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            lineHeight: 1.3,
                            textAlign: "left",
                            alignItems: "start",
                            justifyContent: "center",
                          }}
                          size={4}
                        >
                          <Text
                            strong
                            className={styles.userName}
                            ellipsis
                          >
                            {profileDetails && profileDetails.userName}
                          </Text>
                          <Text
                            type="secondary"
                            strong={false}
                            ellipsis
                          >
                            {getRole(activeUser?.role || activeUser?.currentRole)}
                          </Text>
                        </Space>
                      </Menu.Item>
                    )}
                    {allRoles?.map((item: any) => {
                      return (
                        <Menu.Item
                          key={item}
                          disabled={item == currentRole}
                        >
                          {item == currentRole ? getRole(item) + " (In Use)" : getRole(item)}
                        </Menu.Item>
                      );
                    })}
                    <Menu.Item
                      key="logout"
                      onClick={() => logout()}
                    >
                      Logout
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Space
                  size={"small"}
                  style={{ display: "inline-flex", alignItems: "center" }}
                >
                  <Text className="userNameLogo">{nameLogo}</Text>
                  {lg && (
                    <Space
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        lineHeight: 1.2,
                        textAlign: "left",
                        alignItems: "start",
                        justifyContent: "center",
                      }}
                      size={4}
                    >
                      <Text
                        strong
                        className={styles.userName}
                        ellipsis
                      >
                        {profileDetails && profileDetails.userName}
                        {/* {profileDetails.userName
                          ? profileDetails.userName
                          : user && user.email && user.email.split("@")[0]} */}
                      </Text>
                      <Text
                        type="secondary"
                        strong={false}
                        ellipsis
                      >
                        {getRole(activeUser?.role || activeUser?.currentRole)}
                      </Text>
                    </Space>
                  )}
                  <Icon
                    icon="ep:arrow-down-bold"
                    height="20"
                    style={{ margin: "auto", color: styles.strawberry }}
                  />
                </Space>
              </Dropdown>
            </Typography.Link>
          </div>
        </Col>
      </Row>
      <Modal
        open={openModal}
        maskClosable={false}
        centered
        footer={null}
        closable={false}
      >
        <Result
          status={"403"}
          title={"Role Update Detected!"}
          subTitle={
            <Typography.Text>
              Your role has been modified to {currentRole && getRole(currentRole)} Certain modules may now be
              inaccessible. To access your newly assigned roles, please click on “Update Role.” If you require
              assistance or clarification, kindly reach out to your administrator for support through{" "}
              <b>clmsupport@myairports.com</b>
            </Typography.Text>
          }
          extra={[
            <div style={{ gap: 10, display: "flex", justifyContent: "center" }}>
              <Button
                type="ghost"
                onClick={() => {
                  if (currentRole) {
                    logout();
                  }
                }}
              >
                Logout
              </Button>
            </div>,
          ]}
        />
      </Modal>
      <Modal
        open={openConfirmationModal}
        centered
        footer={null}
        closable={false}
        maskClosable={false}
        onCancel={() => setOpenConfirmationModal(false)}
        title={<div style={{ textAlign: "center", color: "#4CAF50", fontWeight: 700, fontSize: 18 }}>ePOD</div>}
        width={340}
      >
        <div style={{ textAlign: "center", padding: "8px 0 24px" }}>
          <p style={{ fontSize: 15, marginBottom: 24 }}>Are You Sure you want to Shift to ePOD</p>
          <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
            <Button
              onClick={() => setOpenConfirmationModal(false)}
              style={{ width: 100 }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleSpaNavigation}
              style={{ width: 100 }}
            >
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    </Layout.Header>
  );
};
